import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Users, Clock, Heart, BarChart3 } from 'lucide-react';
import { hapticFeedback } from 'lib/native';

const TAB_DEFS = [
  { path: '/dashboard', icon: Home, labelKey: 'nav.dashboard' },
  { path: '/care-circle', icon: Users, labelKey: 'nav.care_circle' },
  { path: '/care-hours', icon: Clock, labelKey: 'nav.care_hours' },
  { path: '/stress-checkin', icon: Heart, labelKey: 'nav.stress_checkin' },
  { path: '/analytics', icon: BarChart3, labelKey: 'nav.analytics' },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleNav = (path) => {
    hapticFeedback('light');
    navigate(path);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 lg:hidden safe-bottom"
      role="navigation"
      aria-label="Mobile navigation"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {TAB_DEFS.map((tab) => {
          const isActive = location.pathname === tab.path ||
            (tab.path === '/dashboard' && location.pathname === '/');
          const label = t(tab.labelKey);
          return (
            <button
              key={tab.path}
              onClick={() => handleNav(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                isActive
                  ? 'text-teal-600'
                  : 'text-slate-400 active:text-slate-600'
              }`}
              data-testid={`mobile-tab-${label.toLowerCase()}`}
              aria-label={label}
              aria-current={isActive ? 'page' : undefined}
            >
              <tab.icon className={`w-5 h-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
              <span className={`text-[10px] font-medium ${isActive ? 'font-semibold' : ''}`}>
                {label}
              </span>
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-teal-500 rounded-full" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
